/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/pipeline.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiPipelineVersion } from './ApiPipelineVersion';
import {
  ApiPipelineVersionFromJSON,
  ApiPipelineVersionFromJSONTyped,
  ApiPipelineVersionToJSON,
  ApiPipelineVersionToJSONTyped,
} from './ApiPipelineVersion';

/**
 *
 * @export
 * @interface ApiListPipelineVersionsResponse
 */
export interface ApiListPipelineVersionsResponse {
  /**
   *
   * @type {Array<ApiPipelineVersion>}
   * @memberof ApiListPipelineVersionsResponse
   */
  versions?: Array<ApiPipelineVersion>;
  /**
   * The token to list the next page of pipeline versions.
   * @type {string}
   * @memberof ApiListPipelineVersionsResponse
   */
  next_page_token?: string;
  /**
   * The total number of pipeline versions for the given query.
   * @type {number}
   * @memberof ApiListPipelineVersionsResponse
   */
  total_size?: number;
}

/**
 * Check if a given object implements the ApiListPipelineVersionsResponse interface.
 */
export function instanceOfApiListPipelineVersionsResponse(
  value: object,
): value is ApiListPipelineVersionsResponse {
  return true;
}

export function ApiListPipelineVersionsResponseFromJSON(
  json: any,
): ApiListPipelineVersionsResponse {
  return ApiListPipelineVersionsResponseFromJSONTyped(json, false);
}

export function ApiListPipelineVersionsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiListPipelineVersionsResponse {
  if (json == null) {
    return json;
  }
  return {
    versions:
      json['versions'] == null
        ? undefined
        : (json['versions'] as Array<any>).map(ApiPipelineVersionFromJSON),
    next_page_token: json['next_page_token'] == null ? undefined : json['next_page_token'],
    total_size: json['total_size'] == null ? undefined : json['total_size'],
  };
}

export function ApiListPipelineVersionsResponseToJSON(json: any): ApiListPipelineVersionsResponse {
  return ApiListPipelineVersionsResponseToJSONTyped(json, false);
}

export function ApiListPipelineVersionsResponseToJSONTyped(
  value?: ApiListPipelineVersionsResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    versions:
      value['versions'] == null
        ? undefined
        : (value['versions'] as Array<any>).map(ApiPipelineVersionToJSON),
    next_page_token: value['next_page_token'],
    total_size: value['total_size'],
  };
}
